const resolveServiceError = async (e) => {
  if (e.response) {
    return e.response.json();
  }
  return e;
};

export default resolveServiceError;
